
import requestAPI from '@/logic/requestBeApi';
import store from '@/store';
import CountryInput from '@/components/Inputs/CountryInput.vue';
import inputValidators from '@/logic/helpers/inputs/validators';
import helpers from './optimizeHelpers';
import disableDates from '@/logic/helpers/dates/disableDates';
import ServerResponseAlert from '@/components/ServerResponseAlert.vue';

export default {
  name: 'AssessorCareer',

  components: {
    CountryInput,
    ServerResponseAlert,
  },

  props: {
    noNextStep: Boolean,
    focusOnProgressCircle: Boolean,
  },

  data(): Record<string, unknown> {
    return {
      disableDates,
      careers: [],
      career: {
        name: '',
        function: '',
        industry: '',
        started: '',
        ended: null,
        country: '',
      },
      careerToEditId: '',
      validationRules: {
        name: [{ validator: inputValidators.primitive, trigger: 'change' }],
        function: [{ validator: inputValidators.primitive, trigger: 'change' }],
        industry: [{ validator: inputValidators.primitive, trigger: 'change' }],
        started: [{ validator: inputValidators.primitive, trigger: 'change' }],
        country: [{ validator: inputValidators.primitive, trigger: 'change' }],
      },
      functionsList: [],
      industriesList: [],
      processingUserDataRequest: false,
      editModeOn: false,
      serverResponse: null,
      showForm: false,
      saveAndQuit: false,
      formIsValid: false,
    };
  },

  computed: {
    careerStart(): string {
      return this.career.started;
    },
  },

  watch: {
    careers(): void {
      this.showForm = !this.careers.length;
    },

    careerStart(): void {
      this.career.ended = null;
    },
  },

  created(): void {
    this.getCareerList();
    this.getExpertiseTypes();
    if (!this.noNextStep) {
      this.career.country = store.state.userCountry;
    }
  },

  methods: {
    async getExpertiseTypes(): Promise<void> {
      const resp = await requestAPI({
        url: '/api/v1/expertise-types?order%5Bexpertises.name%5D=ASC',
        method: 'GET',
      });

      if (resp.ok) {
        const data = await resp.json();

        this.expTypes = data;
        this.functionsList = data.find(
          (obj: { slug: string }) => obj.slug === 'functions',
        ).expertises;
        this.industriesList = data.find(
          (obj: { slug: string }) => obj.slug === 'industries',
        ).expertises;
      }
    },

    getCareerList(): void {
      helpers.getEntries(this, 'career');
    },

    addCareer(): void {
      helpers.createEntry(this, 'career');
    },

    editCareer(): void {
      helpers.updateEntry(this, 'career', this.careerToEditId);
    },

    removeCompany(id: string): void {
      helpers.deleteEntry(this, 'career', id);
    },

    turnOnTheEditMode(idx: number): void {
      helpers.turnOnTheEditMode(this, 'career', idx);
    },

    flushCareer(): void {
      helpers.purgeFormData(this, 'career');
    },
  },
};
